module.exports = __webpack_public_path__ + "img/logo.2021.1816b2f9.png";